
import Login from '../pages/login/NewThemeLogin';
import LanguageSelection from "../pages/language/NewThemeLanguages";
import Disclaimerpage from '../pages/template/disclaimerpage';
import EnterToken from '../pages/mfa/enterToken';
import GeneratePin from '../pages/mfa/generatePin';
import EnterPin from '../pages/mfa/enterPin';
import CheckPin from '../pages/mfa/pinCheck';
const routes = [
    {
      path: "/login",
      name: "Login",
      displayName: "Login",
      component: Login
    },
    {
      path: "/selectlanguage",
      name: "selectlanguage",
      displayName: "selectlanguage",
      component: LanguageSelection,
    },
    {
      path: "/disclaimerpage",
      name: "disclaimerpage",
      displayName: "disclaimerpage",
      component: Disclaimerpage,
    },
    {
      path: "/enterToken",
      name: "enterToken",
      displayName: "enterToken",
      component: EnterToken,
    },
    {
      path: "/generatePin",
      name: "generatePin",
      displayName: "generatePin",
      component: GeneratePin,
    },
    {
      path: "/enterPin",
      name: "enterPin",
      displayName: "enterPin",
      component:EnterPin,
    },
    {
      path: "/checkPin",
      name: "checkPin",
      displayName: "checkPin",
      component:CheckPin,
    },
    {
      redirect: true, 
       path: "/", 
       to: "/login", 
      // name: "Login" 

      //default: "/",
      name: "Login",
      displayName: "Login",
      component: Login,
    }
    
];

export default routes;